// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SolutionOutlined from '/root/agent/work/cc3543e1b1464b4f/node_modules/.pnpm/@ant-design+icons@4.8.3_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@ant-design/icons/es/icons/SolutionOutlined';
import SmileOutlined from '/root/agent/work/cc3543e1b1464b4f/node_modules/.pnpm/@ant-design+icons@4.8.3_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@ant-design/icons/es/icons/SmileOutlined';
export default { SolutionOutlined, SmileOutlined };
